module.exports = __webpack_public_path__ + "static/media/essadek-frioui.85a1ccc4.jpg";